import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'spa-list-template',
  templateUrl: './spa-list-template.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpaListTemplateComponent {
  @Input() templateKey = '';
  @ContentChild(TemplateRef) template: TemplateRef<unknown> | undefined;
}
